export default __webpack_public_path__ + "img/1332be06042481e2065e8b48e094c1be.svg";